export const AIRPORTS_KEY = "airports";

export const INTER_FLIGHT_SEARCH_HISTORY_LOCAL_STORAGE_KEY =
  "flight-intl-search-history";
export const INTER_FLIGHT_ROUTE_HISTORY_LOCAL_STORAGE_KEY =
  "flight-intl-route-history";

export const DOM_FLIGHT_SEARCH_HISTORY_LOCAL_STORAGE_KEY =
  "flight-dom-search-history";
export const DOM_FLIGHT_ROUTE_HISTORY_LOCAL_STORAGE_KEY =
  "flight-dom-route-history";

export const SEARCH_SUGGESTION_KEY = "search_suggestion";

export const DETAIL_BADGE = "DETAIL_BADGE";
export const CANCELLATION_POLICY_ACCORDION = "CANCELLATION_POLICY_ACCORDION";

export const PRICE_ALERT_KEY = "price_alert";

export const PRICE_TABLE_SKELETON = "PRICE_TABLE_SKELETON";
export const PRICE_TABLE_ITEM = "price_table_item";

export const OPEN_SEARCH_KEY = "OPEN_SEARCH";
